import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';
import { Global } from '../../services/global'
import {LoginService} from '../../services/login/login.service'
import { LoadingService } from '../../services/general/loading.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-google-login',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './google-login.component.html',
  styleUrl: './google-login.component.css'
})
export class GoogleLoginComponent implements OnInit {
  private API_URL = Global.url + '/reset'; 
  // Parámetros de configuración de OAuth desde environment
 
  private readonly clientId = environment.oauth.clientId;
  private readonly redirectUri = `${this.API_URL}/CognitoCallback`; //Si se desea apuntar al local para hacer pruebas cambiar en el enviroment:  apiUrl: 'http://localhost:5000/api/v1' 
  private readonly cognitoDomain = environment.oauth.cognitoDomain; 
  private readonly identityProvider = environment.oauth.identityProvider;
  private readonly scopes = environment.oauth.scopes;  

  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private _loadingService: LoadingService,
  ) {}

  ngOnInit(): void {
    try {
      const code = this.route.snapshot.queryParamMap.get('code');

      // Solo intercambiamos el código si viene en la URL (luego del login con Google)
      if (code) {
        this.exchangeCodeForToken(code);
      }
    } catch (error) {
      console.error('Error al leer los parámetros de la URL:', error);
      alert('Hubo un problema al procesar la autenticación. Intenta de nuevo.');
    }
  }

  /**
   * Redirige al usuario al login de Google mediante Cognito
   */
  loginWithGoogle(): void {
    const oauthUrl = `${this.cognitoDomain}/oauth2/authorize?response_type=code&client_id=${this.clientId}&redirect_uri=${encodeURIComponent(this.redirectUri)}&identity_provider=${this.identityProvider}&scope=${this.scopes.join('+')}`;
    window.location.href = oauthUrl;
    this._loadingService.setLoading(true)
  }

  /**
   * Intercambia el código recibido por los tokens y datos del usuario
   * Guarda el email en sessionStorage y redirige al siguiente paso del flujo
   */
  private exchangeCodeForToken(code: string): void {
    this._loadingService.setLoading(true)
    this.http.post(`${this.API_URL}/token`, { code }).subscribe({
      next: (resp: any) => {
        if (!resp) {
          console.warn('La respuesta del backend no contiene un email válido:', resp);
          alert('No se pudo recuperar la información del usuario o no tiene un correo y email valido.');
          return;
        }
        // Guardar en sessionStorage
        sessionStorage.setItem('email', resp.email);
        
        // Guardar en localStorage igual que el login normal
        localStorage.setItem('authToken', resp.id_token);
        localStorage.setItem('userName', resp.email);
        
        this.loginService.setCookie(resp.id_token).subscribe({
              next: (response) => {
                this.router.navigate(['/password']); // Redirigir a la ruta protegida
                this._loadingService.setLoading(false)
              },
              error: (error) => {
                console.error('No se creo la cookie de sesion:', error);
              }  
        })
      },
      error: (err) => {
        console.error('Fallo al intercambiar el código:', err);
        alert('Ocurrió un error al conectarse con el servidor y se verifico tu correo electronico. Cierra la pestaña y intenta nuevamente.');
      }
    });
  }
}